// API Configuration - Direct Cloud Run Backend
const API_BASE_URL = 'https://cost-to-construction-api-562394171179.us-central1.run.app';

export default API_BASE_URL;
